// import Cookies from "js-cookie";
// import { Navigate, Outlet } from "react-router-dom";

// const ProtectRoute = ({ isPrivate = false, children }) => {
//   const token = localStorage.getItem("access_token");
//   const refreshToken = Cookies.get("refresh_token");
//     console.log("🚀 ~ ProtectRoute ~ refreshToken:", refreshToken)
//     if (isPrivate && !token && !refreshToken) {
//     return <Navigate to="/login" replace />;
//   }

//   if (!isPrivate && token) {
//     return <Navigate to="/dashboard" replace />;
//   }

//   if (children) return children;

//   return <Outlet />;
// };

// export default ProtectRoute;





// import { useLocation, Navigate, Outlet } from "react-router-dom";
// import Cookies from "js-cookie";

// const ProtectRoute = ({ isPrivate = false, children }) => {
//   const token = localStorage.getItem("access_token");
//   const refreshToken = Cookies.get("refresh_token");
//   const location = useLocation();

//   const publicOnlyPaths = ["/login", "/forgot-password", "/new-password"];
//   const isPublicOnlyPath = publicOnlyPaths.some((path) =>
//     location.pathname.startsWith(path)
//   );

//   if (!token && !refreshToken && !isPublicOnlyPath) {
//     return <Navigate to="/login" replace />;
//   }

//   if (token && isPublicOnlyPath) {
//     return <Navigate to="/dashboard" replace />;
//   }

//   return children ? children : <Outlet />;
// };

// export default ProtectRoute;



import { useLocation, Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";

const ProtectRoute = ({ isPrivate = false, children }) => {
  const token = localStorage.getItem("access_token");
  const refreshToken = Cookies.get("refresh_token");
  const location = useLocation();

  // Remove "/new-password" from publicOnlyPaths
  const publicOnlyPaths = ["/login", "/forgot-password"]; // ✅ removed "/new-password"
  const isPublicOnlyPath = publicOnlyPaths.includes(location.pathname);

  // ✅ Redirect immediately if no token at all (except for public paths and new-password)
  if (!token && !refreshToken && !isPublicOnlyPath && !location.pathname.startsWith("/new-password")) {
    return <Navigate to="/login" replace />;
  }

  // ✅ If logged in and on a public-only path, redirect to dashboard
  // This won't affect /new-password since it's not in publicOnlyPaths anymore
  if (token && isPublicOnlyPath) {
    return <Navigate to="/dashboard" replace />;
  }

  if (children) return children;
  return <Outlet />;
};

export default ProtectRoute;